import { wrapRootElement as wrap } from './src/utils/wrapRootElement.js';
import 'typeface-lekton';
import 'typeface-open-sans';

export const wrapRootElement = wrap;
